import { useTranslation } from 'react-i18next';

const SwitchLang = ({ previewLang, setPreviewLang, className }) => {
    const { t } = useTranslation();
    return (
        <div
            style={{
                borderTop: '1px solid #DBDBDB',
                borderBottom: '1px solid #DBDBDB',
            }}
            className={`py-4 flex space-x-2 text-tiny ${className}`}
        >
            <span
                style={{ borderRight: '1px solid #DBDBDB' }}
                onClick={() => {
                    setPreviewLang('th');
                }}
                className={`${
                    previewLang === 'th' ? 'text-purple-PHX font-semibold' : ''
                } cursor-pointer hover:opacity-80 pr-2`}
            >
                {t('policy.th')}
            </span>
            <span
                onClick={() => {
                    setPreviewLang('en');
                }}
                className={`${
                    previewLang === 'en' ? 'text-purple-PHX font-semibold' : ''
                } cursor-pointer hover:opacity-80`}
            >
                {t('policy.en')}
            </span>
        </div>
    );
};

export default SwitchLang;
